import { useMemo } from 'react';
import { useTheme } from 'styled-components';

import { Message, MessageOptions } from '@dreryk/react-components';

import { annulledPrescriptionsTranslationKeys } from '../../../../translations';

type PrescriptionStatusType = 'ANNULLED';

type PrescriptionStateMap = Record<PrescriptionStatusType, string>;

const useSentPrescriptionMessageOptions = (): MessageOptions<PrescriptionStateMap> => {
   const theme = useTheme();
   return useMemo((): MessageOptions<PrescriptionStateMap> => {
      return {
         ANNULLED: {
            color: theme.error,
            backgroundColor: theme.errorLighter,
            labelColor: theme.textBody,
         },
      };
   }, [theme.error, theme.errorLighter, theme.textBody]);
};

export const SentPrescriptionStatus = (): JSX.Element => {
   const options = useSentPrescriptionMessageOptions();
   return (
      <Message<PrescriptionStateMap>
         testId={'sentPrescriptionStatus'}
         label={annulledPrescriptionsTranslationKeys.annulled}
         type={'ANNULLED'}
         displayIndicator
         options={options}
      />
   );
};
